import type { MemberAssociationResponse } from "@finn-no/mobility-dealer-types";
import { BrandURL } from "@mobility-item-page/types";
import { ElementType, Intent, TargetType } from "@mobility-item-page/utilities/client";
import { useAppConfig } from "../../../../context/AppConfigProviderContext.tsx";
import usePulse from "../../../../utils/pulse-tracking/usePulse.ts";
import { Icon } from "../../Icon.tsx";

type Props = {
  memberAssociations: MemberAssociationResponse[];
};

const TradeOrg = ({ memberAssociations }: Props) => {
  const { brand } = useAppConfig();
  const { trackClick } = usePulse();
  const host = BrandURL[brand as keyof typeof BrandURL];

  const trackLinkClick = ({
    targetTitle,
    linkUrl,
    targetType,
  }: {
    targetTitle: string;
    linkUrl: string;
    targetType: TargetType.Page | TargetType.ExternalContent;
  }) => {
    trackClick({
      name: "Read about member association",
      objectId: "MO_ev98",
      elementType: ElementType.Link,
      intent: Intent.Open,
      position: "Safety elements",
      target: {
        id: linkUrl,
        type: targetType,
        name: targetTitle,
      },
    });
  };

  return (
    <>
      {memberAssociations.map((association) => {
        const url = association.link?.url;
        const externalLink = url ? new URL(url).host.replace(/^(?:www|local|dev)\./, "") !== host : false;
        return (
          <div className="mb-16" key={association.title}>
            <p className="mt-16 md:mt-0 mb-0">{association.description}</p>
            {url && (
              <p className="mt-16 md:mt-8 mb-0">
                <a
                  className="flex items-center gap-4"
                  href={url}
                  onClick={() =>
                    trackLinkClick({
                      targetTitle: association.title,
                      linkUrl: url,
                      targetType: externalLink ? TargetType.ExternalContent : TargetType.Page,
                    })
                  }
                >
                  {association.link?.text}
                  {externalLink && <Icon name={"LinkExternal"} />}
                </a>
              </p>
            )}
          </div>
        );
      })}
    </>
  );
};

export default TradeOrg;
